"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DomainEmailsConfig = {
    blackListedDomains: [],
    whiteListedDomains: [],
};
exports.default = DomainEmailsConfig;
